export default (languageCode: string) => /* GraphQL */ `
  query GetLists{
    lists: lists {
      isSelected
      listId
      name
      updated
      quantity
      retail(languageCode: "${languageCode}") {
        items {
          itemNo
          quantity
          product
            {
              images {
                url
                quality
              }
              globalName
            }
          }
        }
    }
  }
`;
